import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinterHoardParsedInitData} from "../server/data/IWinterHoardServerData";

export class SoundPlayer {
    private static currentLoop: string = "";
    private static anticipationSoundIsPlaying: boolean = false;
    private static scatterCounter: number = -1;
    private static isNewRound: boolean = false;
    private _mode: string = "";
    private static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onReady());
    }

    private onInitDataParsed(data: WinterHoardParsedInitData): void {
        this._mode = data.mode;
    }

    private onReady(): void {
        if (this._mode === GameMode.NORMAL) {
            SoundPlayer.playAmbientLoop(WinterHoardSoundConfig.instance.BASIC_GAME_AMBIANCE, 0);
        } else {
            SoundPlayer.playAmbientLoop(WinterHoardSoundConfig.instance.FREE_SPIN_AMBIANCE, 0);
        }
    }

    public static resetScatterSoundCounter():void {
        SoundPlayer.scatterCounter = -1;
        SoundPlayer.isNewRound = true;
    }

    public static playScatterSound():void {
        SoundPlayer.scatterCounter++;
        this.soundPlayer.playEffect(WinterHoardSoundConfig.SCATTER_COUNTER_UP[SoundPlayer.scatterCounter>2?2:SoundPlayer.scatterCounter]);
    }

    public static playAmbientLoop(name: string, duration: number, volume?: number): void {
        this.currentLoop = name;
        const nHowl = this.soundPlayer.playTrack({
            name: this.currentLoop
        });
        if (duration > 0 && nHowl){
            nHowl.fade(0,1,duration);
        }
    }


    public static pauseAmbience(): void {
        SoundPlayer.stopEffect(this.currentLoop);
    }

    public static resumeAmbience(): void {
        this.soundPlayer.playTrack({
            name: this.currentLoop
        });
    }

    public static stopSound(name: string, fadeOutDuration?: number): void {
        this.soundPlayer.stopTrack(name)
    }

    public  static playEffect(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume,
        });
    }

    public  static stopEffect(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static playAnticipationSound(gameMode:string): void {
        if(!SoundPlayer.anticipationSoundIsPlaying && SoundPlayer.isNewRound) {
            SoundPlayer.anticipationSoundIsPlaying = true;
            this.soundPlayer.playTrack({name: WinterHoardSoundConfig.ANTICIPATION});
            if(gameMode === GameMode.NORMAL){
                SoundPlayer.fadeOutMainBGSound(500);
            }else{
                SoundPlayer.fadeOutFSBGSound(500);
            }
        }
    }

    public static stopAnticipationSound(hasWin:boolean, gameMode:string): void {
        SoundPlayer.anticipationSoundIsPlaying = false;
        SoundPlayer.scatterCounter = -1;
        SoundPlayer.isNewRound =false;
        if(!hasWin){
            this.soundPlayer.playEffect(WinterHoardSoundConfig.ANTICIPATION_FAIL);
        }
        if(gameMode === GameMode.NORMAL){
            SoundPlayer.fadeInMainBGSound(500);
        }else{
            SoundPlayer.fadeInFSBGSound(500);
        }
        this.soundPlayer.stopTrack( WinterHoardSoundConfig.ANTICIPATION);

    }
    public static stopAnticipationEffect(): void {
        this.soundPlayer.stopTrack(WinterHoardSoundConfig.ANTICIPATION);
    }
    public static fadeInMainBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: WinterHoardSoundConfig.instance.BASIC_GAME_AMBIANCE,
            duration: duration,
            to: 1
        });
    }

    public static fadeOutMainBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: WinterHoardSoundConfig.instance.BASIC_GAME_AMBIANCE,
            duration: duration,
            to: 0
        });
    }

    public static fadeInFSBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: WinterHoardSoundConfig.instance.FREE_SPIN_AMBIANCE,
            duration: duration,
            to: 1
        });
    }

    public static fadeOutFSBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: WinterHoardSoundConfig.instance.FREE_SPIN_AMBIANCE,
            duration: duration,
            to: 0
        });
    }

    public static playNormalWinSound(winRatioConfig: IWinRatioConfig) {
        let soundName: string = "";
        switch (winRatioConfig.type) {
            case WinRatioType.TINY:
                soundName = WinterHoardSoundConfig.TINY_WIN;
                break;
            case WinRatioType.SMALL:
                soundName = WinterHoardSoundConfig.SMALL_WIN;
                break;
            case WinRatioType.MEDIUM:
                soundName = WinterHoardSoundConfig.MEDIUM_WIN;
                break;
            case WinRatioType.LARGE:
                soundName = WinterHoardSoundConfig.LARGE_WIN;
                break;
            default:
                soundName = "";
                break;
        }
        SoundPlayer.playEffect(soundName);
    }
}